const actionTypes = { SET_BEAUTY_OFFER: 'SET_BEAUTY_OFFER' };

module.exports = actionTypes;
